import React from "react";
import "./SkeletonStyle/SkeletonStyle.css";
export const BudgetSkeleton = () => {
  return (
    <div>
      {/* Skeleton for budgetMain */}
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
        <div
          className="skeleton"
          style={{ width: "33%", height: "200px" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "33%", height: "200px" }}
        ></div>
        <div
          className="skeleton"
          style={{ width: "33%", height: "200px" }}
        ></div>
      </div>
    </div>
  );
};
